import React, { useState, useEffect } from "react";
import { Modal, Checkbox, Avatar, List, Input, Button } from "antd";
import "./AssignCoParentToModal.css"; // Assuming you have some CSS for styling
const AssignToModal = ({
  visible,
  onCancel,
  onSave,
  selectedUsers,
  users,
  selectedCoupleId,
 couples,
}) => {
  const [localSelected, setLocalSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const parentCouple = couples.find((couple) => couple.id === selectedCoupleId);
  // console.log(selectedUsers, "selectedUsers");
  
  const parentUsers = [
  {
    id: parentCouple?.parent1.user_id,
    name: parentCouple?.parent1.nickname || parentCouple?.parent1.name,
    email: parentCouple?.parent1.email,
    avatar: "", // Add avatar URL if available
  },
  {
    id: parentCouple?.parent2.user_id,
    name: parentCouple?.parent2?.nickname || parentCouple?.parent2.name,
    email: parentCouple?.parent2?.email,
    avatar: "", // Add avatar URL if available
  },
];
  useEffect(() => {
    setLocalSelected(selectedUsers);
  }, [selectedUsers]);
  // console.log("users>>>", users);
  // const handleUserToggle = (id) => {
  //   setLocalSelected((prev) =>
  //     prev.includes(id) ? prev.filter((u) => u !== id) : [...prev, id]
  //   );
  // };
  const handleUserToggle = (id) => {
  setLocalSelected((prev) => {
    const isSelected = prev.some(selected => selected.parent_id === id);
    
    if (isSelected) {
      return prev.filter(selected => selected.parent_id !== id);
    } else {
      // Find the user in couples data to get their details
      const foundParent = [parentCouple?.parent1, parentCouple?.parent2]
        .find(parent => parent?.user_id === id);
      
      // Create a new object matching your structure with couples data
      const newSelection = {
        record_id: null, // You may need to generate this
        parent_id: id,
        coparent_email: foundParent?.email || null,
        coparent_nickname: foundParent?.nickname || null,
        profile_image_path: foundParent?.profile_image_path || null, 
        name: foundParent?.name || null 
      };
      return [...prev, newSelection];
    }
  });
};
  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  // console.log("parentUsers", parentUsers,localSelected);
  return (
    <Modal
      title="Assign To"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={() => onSave(localSelected)}>
          Save
        </Button>,
      ]}
    >
      <Input
        placeholder="Search by name"
        value={searchTerm}
        className="assignToSearch"
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: 12 }}
      />

      <List
      itemLayout="horizontal"
      dataSource={parentUsers} // filteredUsers should be based on combinedUsers
      renderItem={(user) => (
        <List.Item
          actions={[
            <Checkbox
              checked={localSelected.some(selected => selected.parent_id === user.id)}
              onChange={() => handleUserToggle(user.id)}
            />,
          ]}
        >
          <List.Item.Meta
            avatar={
              <Avatar 
                src={
                  localSelected.find(selected => selected.parent_id === user.id)?.profile_image_path || 
                  user.avatar || 
                  "https://api.quelld.webdezign.uk/storage/default/default_profile.png"
                } 
              />
            }
            title={user.name}
            description={user.email}
          />
        </List.Item>
      )}
    />
    </Modal>
  );
};

export default AssignToModal;
